"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingMethodCardCms = void 0;
var ShippingMethodCardCms = /** @class */ (function () {
    function ShippingMethodCardCms() {
        this.expressShippingLabel = 'Express shipping';
        this.expressShippingDeliveryDaysLabel = 'Delivered in 2-3 business days';
        this.standardShippingLabel = 'Standard shipping';
        this.standardShippingDeliveryDaysLabel = 'Delivered within 1-2 weeks';
        this.nextdayShippingLabel = 'Next-day delivery';
        this.nextdayShippingDeliveryDaysLabel = 'Your order will arrive tomorrow';
        this.freeShippingLabel = 'FREE';
        this.deliveryBBText = 'Delivered in 1 - 5 business days';
        this.dtvnEquipmentText = 'TV equipment';
        this.bbEquipmentText = 'Wi-Fi&reg; gateway & setup kit';
        this.overnightShippingBBTVLabel = 'Standard overnight shipping';
        this.shippingChargesLabel = 'plus tax, due today';
        this.expressShippingAttTvDaysLabel = 'Delivered in 1 - 2 business days';
        this.attTvLabel = "AT&T TV device";
        this.shippingSMBWithBBLabel = 'Express shipping';
        this.deliverySMBWithBBLabel = 'Delivery in 1 - 2 business days';
        this.attTvAndAppleTvLabel = 'AT&T TV device + Apple TV 4K';
    }
    return ShippingMethodCardCms;
}());
exports.ShippingMethodCardCms = ShippingMethodCardCms;
//# sourceMappingURL=ShippingMethodCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/ShippingMethodsCard/ShippingMethodCard.cms.js
// module id = 1996
// module chunks = 8